/* RESPONSIBLE TEAM: team-fin-voice */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class FinAIAgentSettingsPronunciationsRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.replaceWith('apps.app.settings.ai-automation.pronunciations');
  }
}
